
import moment from 'moment';
import { getData, getTimestampData } from '@/components/report/service';
import {
  SiteArriveQuery,
  SiteArriveQueryDetails,
} from '../Sql';
import { SqlBase } from '../../../common';

const dateRange = [
  moment(new Date()).add(-14, 'days'),
  moment(new Date()).add(0, 'days')
]
export default {
  namespace: 'centerDepartBoardSiteArriveModal',
  state: {
    dates: {},
    // 网点table
    page: 1, 
    siteData: [],

    dateRange: dateRange,
    modalVisible: false,
    modalType: '',
    modalTitle: '',
    dateType: undefined,
  },
  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          page: 1, 
          siteData: [], 
        },
      });
    },
    // 重置二级弹层
    *setResetModal(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          dateRange: dateRange,
          modalVisible: false,
          dateType: undefined,
          siteDetailsData: [],
          siteProductData: [],
        },
      });
    },
    *getSelect(_, { put }) {
      yield put({ type: 'getSiteDetails' });
    },
    /**
     * 网点列表
    */
    *getSiteDetails(_, { call, put, select }) {
      let centerFilter = yield select(({ centerDepartBoard }) => centerDepartBoard.searchParams.centerFilter);
      let query = yield select(({ centerDepartBoardModals }) => {
        return {
          dateType: centerDepartBoardModals.dateType,
          startDate: moment(centerDepartBoardModals.dateRange[0]),
          endDate: moment(centerDepartBoardModals.dateRange[1])
        }
      });
      const filter = SiteArriveQuery({
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        scanSite: centerFilter,
      });
      const params = {
        aggregators: SqlBase()
      }
      const day = query.endDate.diff(query.startDate, 'day');
      const beginStartDate = query.endDate.add(-1, 'days').format('YYYY-MM-DD 12:00:00');
      const beginEndDate = query.endDate.add(1, 'days').format('YYYY-MM-DD 12:00:00');
      const beginStartDate2 = query.endDate.add(-2, 'days').format('YYYY-MM-DD 12:00:00');
      const data = yield call(getData, { ...params, ...filter[0] });
      // 今日
      const data2 = yield call(getData, { ...params, ...filter[0], ...{
        startDate: beginStartDate,
        endDate: beginEndDate
      }});
      // 昨日
      const data3 = yield call(getData, { ...params, ...filter[0], ...{
        startDate: beginStartDate2,
        endDate: beginStartDate
      }});

      data && data.forEach((item, index) => {
        item.index = index;
        item.goodsWeight3 = item.goodsWeight / day;
        const result = data2.find(item2 => item2.destinationSite === item.destinationSite);
        if (result) {
          item.goodsWeight1 = result.goodsWeight
        }
        const result2 = data3.find(item2 => item2.destinationSite === item.destinationSite);
        if (result2) {
          item.goodsWeight2 = result2.goodsWeight
        }
      });
      yield put({
        type: 'update',
        payload: {
          siteData: data || [],
          dates: {
            beginDate: moment(beginStartDate2).format('YYYY-MM-DD'),
            nowDate: moment(beginStartDate).format('YYYY-MM-DD'),
            endDate: moment(beginEndDate).format('YYYY-MM-DD'),
          }
        },
      });
    },
    
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
}